import { render, staticRenderFns } from "./flfgxq.vue?vue&type=template&id=87b37bba&scoped=true&"
import script from "./flfgxq.vue?vue&type=script&lang=js&"
export * from "./flfgxq.vue?vue&type=script&lang=js&"
import style0 from "./flfgxq.vue?vue&type=style&index=0&id=87b37bba&scoped=true&lang=css&"
import style1 from "./flfgxq.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b37bba",
  null
  
)

export default component.exports